'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import keyMirror from 'react-utils/keyMirror';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIList from 'UIComponents/list/UIList';
import ToolFieldset from 'DesignComponents/tool/ToolFieldset';
import Small from 'UIComponents/elements/Small';
import Tool from 'DesignComponents/tool/Tool';
import ToolBreadcrumbs from 'DesignComponents/tool/ToolBreadcrumbs';
import ToolSections from 'DesignComponents/tool/ToolSections';
import IconSelect from 'DesignEditorsUI/components/customWidgetEditor/sidebar/icon/IconSelect';
import IconTypes from 'ContentUtils/constants/IconTypes';
import { DEFAULT_ICON_SET } from 'ContentUtils/constants/IconSets';

const i18nKey = key => `DesignEditorsUI.customWidgetEditor.sidebar.icon.${key}`;

const MAX_FILE_SIZE_IN_BYTES = 10000;
const ICON_REQUIREMENTS = keyMirror({
  IS_SVG: null,
  IS_SIZE_LESS_THAN_MAX: null
});
export default class IconSidebar extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      errors: {}
    };

    this.onBackToFieldsClick = () => {
      this.props.setIsSelectingIcon(false);
    };

    this.onFileSelect = fileData => {
      const errors = {};
      const {
        extension = '',
        size,
        url
      } = fileData;

      if (extension.toLowerCase() !== 'svg') {
        errors[ICON_REQUIREMENTS.IS_SVG] = true;
      }

      if (size && size > MAX_FILE_SIZE_IN_BYTES) {
        errors[ICON_REQUIREMENTS.IS_SIZE_LESS_THAN_MAX] = true;
      }

      this.setState({
        errors
      });

      if (!Object.keys(errors).length) {
        this.props.updateIcon(url);
      }
    };

    this.onIconSelect = iconData => {
      const {
        name,
        type,
        iconSet
      } = iconData;
      let icon = encodeURIComponent(name);

      if (iconSet && iconSet !== DEFAULT_ICON_SET) {
        icon = `${iconSet}:${icon}`;
      }

      if (type && type !== IconTypes.REGULAR) {
        icon = `${icon}:${type}`;
      }

      this.props.updateIcon(icon);
    };

    this.onResetToDefault = () => {
      this.setState({
        errors: {}
      });
      this.props.updateIcon(null);
    };

    this.renderIconRequirement = requirement => {
      const isError = this.state.errors[requirement];
      const className = 'icon-requirements-list-item' + (isError ? " is--error" : "");
      const use = isError ? 'error' : null;
      return /*#__PURE__*/_jsx(Small, {
        className: className,
        use: use,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey(`iconRequirements.requirements.${requirement}`)
        })
      }, requirement);
    };
  }

  renderBreadcrumbs() {
    return /*#__PURE__*/_jsx(ToolBreadcrumbs, {
      singleBreadcrumbIsBackLink: true,
      children: /*#__PURE__*/_jsx(UILink, {
        onClick: this.onBackToFieldsClick,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('backToFields')
        })
      })
    });
  }

  renderIconRequirements() {
    const errorMessage = Object.keys(this.state.errors).length ? /*#__PURE__*/_jsx(Small, {
      use: "error",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('iconRequirements.error')
      })
    }) : null;
    const requirements = Object.keys(ICON_REQUIREMENTS).map(this.renderIconRequirement);
    return /*#__PURE__*/_jsxs("div", {
      children: [errorMessage, /*#__PURE__*/_jsx(UIList, {
        className: "icon-requirements-list",
        children: requirements
      })]
    });
  }

  render() {
    const requirementsLabel = /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('iconRequirements.label')
    });

    return /*#__PURE__*/_jsx(Tool, {
      className: "icon-sidebar-container",
      breadcrumbsContent: this.renderBreadcrumbs(),
      children: /*#__PURE__*/_jsxs(ToolSections, {
        children: [/*#__PURE__*/_jsx(IconSelect, {
          customWidgetIcon: this.props.customWidgetIcon,
          onResetToDefault: this.onResetToDefault,
          onFileSelect: this.onFileSelect,
          onIconSelect: this.onIconSelect
        }), /*#__PURE__*/_jsx(Small, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('colorWarning')
          })
        }), /*#__PURE__*/_jsx(ToolFieldset, {
          children: /*#__PURE__*/_jsx(UIFormControl, {
            label: requirementsLabel,
            children: this.renderIconRequirements()
          })
        })]
      })
    });
  }

}
IconSidebar.propTypes = {
  customWidgetIcon: PropTypes.string,
  setIsSelectingIcon: PropTypes.func.isRequired,
  updateIcon: PropTypes.func.isRequired
};